// extracted by mini-css-extract-plugin
export default {"card-inner-wrapper":"FontCard_card-inner-wrapper__M1wHf","font-family-wrapper":"FontCard_font-family-wrapper__UTPjo","font-card-wrapper":"FontCard_font-card-wrapper__yVvoT"};